module.exports = "/* Header */\n#collections-container-experience {\n  height: 100vh;\n  overflow: hidden;\n  background-image: url(\"/assets/img/galeria.jpg\");\n  background-size: cover; }\n#collections-container-experience__item {\n    cursor: pointer; }\n#collections-container-experience__item img {\n      max-height: 70vh;\n      max-width: 340px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/experience/experience.component.scss
// module id = ./src/app/experience/experience.component.scss
// module chunks = main